import classNames from 'classnames';

export const getToggleCircleClass = ({
  activeState,
  loading,
  disabled,
}: {
  activeState: boolean;
  loading: boolean;
  disabled?: boolean;
}) =>
  classNames(
    'transition-transform duration-500 ease-in-out transform rounded-full flex items-center justify-center w-4 h-4 shadow-[0px_3px_8px_0px_rgba(0,0,0,0.12),0px_3px_1px_0px_rgba(0,0,0,0.04)]',
    {
      'bg-primary': activeState && !loading && !disabled,
      'bg-white': !activeState && !loading && !disabled,
      'bg-white/50 dark:bg-white/30': disabled && !loading,
      'bg-neutral-30': loading,
      'translate-x-0': !activeState && !loading,
      'translate-x-2': loading,
      'translate-x-4': activeState && !loading,
    }
  );
